/* assets/ishaker-cart.js — AJAX quantity stepper + remove modal for iShaker Cart */
(function () {
  'use strict';

  var section = document.querySelector('.ishaker-collection');
  if (!section) return;

  /* ── Helpers ── */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text) node.textContent = text;
    return node;
  }

  /* ── Modal elements ── */
  var modal = document.getElementById('cartRemoveModal');
  var btnCancel = document.getElementById('cartModalCancel');
  var btnDelete = document.getElementById('cartModalDelete');
  var btnClose = document.getElementById('cartModalClose');
  var backdrop = modal ? modal.querySelector('.ishaker-cart-modal__backdrop') : null;
  var pendingRemoveKey = null;

  /* Move modal to <body> so no parent transform breaks backdrop-filter */
  if (modal) document.body.appendChild(modal);

  function openModal(key) {
    pendingRemoveKey = key;
    modal.hidden = false;
  }

  function closeModal() {
    modal.hidden = true;
    pendingRemoveKey = null;
  }

  /* ── Pending changes queue (for debounced API calls) ── */
  var pendingChanges = {}; /* key → desired quantity */
  var syncTimer = null;
  var SYNC_DELAY = 400; /* ms — batch rapid clicks into one API call */

  /* Send all pending changes to Shopify in one request */
  function syncCart() {
    var updates = {};
    var keys = Object.keys(pendingChanges);
    if (keys.length === 0) return;

    keys.forEach(function (key) {
      updates[key] = pendingChanges[key];
    });
    pendingChanges = {};

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateUI(cart); })
      .catch(function () {
        /* On error, reload to get correct state */
        window.location.reload();
      });
  }

  function scheduleSyncCart() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncCart, SYNC_DELAY);
  }

  /* Single-item change (used only by remove modal) */
  function changeCartItem(key, qty, callback) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (callback) callback(cart); })
      .catch(function () {});
  }

  /* ── Optimistic UI update (instant, no waiting for server) ── */
  function optimisticUpdate(row, newQty, unitPrice) {
    /* Update quantity input */
    var qtyVal = row.querySelector('.ishaker-cart__qty-value');
    if (qtyVal) qtyVal.value = newQty;

    /* Update line price */
    var priceEl = row.querySelector('.ishaker-cart__row-price');
    if (priceEl) priceEl.textContent = formatMoney(unitPrice * newQty);

    /* Update button data attributes */
    var minusBtn = row.querySelector('.ishaker-cart__qty-minus');
    var plusBtn = row.querySelector('.ishaker-cart__qty-plus');
    if (minusBtn) minusBtn.dataset.qty = newQty - 1;
    if (plusBtn) plusBtn.dataset.qty = newQty + 1;

    /* Update summary totals optimistically */
    updateSummaryFromDOM();
  }

  /* Recalculate summary from visible rows */
  function updateSummaryFromDOM() {
    var rows = section.querySelectorAll('.ishaker-cart__row');
    var totalCents = 0;
    var totalItems = 0;

    rows.forEach(function (row) {
      var qtyVal = row.querySelector('.ishaker-cart__qty-value');
      var qty = qtyVal ? parseInt(qtyVal.value, 10) : 0;
      var unitPrice = parseInt(row.dataset.unitPrice || '0', 10);
      totalItems += qty;
      totalCents += unitPrice * qty;
    });

    var countEl = section.querySelector('.ishaker-cart__summary-count');
    var totalEl = section.querySelector('.ishaker-cart__summary-total');
    if (countEl) countEl.textContent = totalItems + ' item' + (totalItems !== 1 ? 's' : '');
    if (totalEl) totalEl.textContent = formatMoney(totalCents);

    /* Update header cart count */
    var headerCount = document.querySelector('.ishaker-cart-count');
    if (headerCount) headerCount.textContent = totalItems;
  }

  /* Update the DOM after server responds (source of truth) */
  function updateUI(cart) {
    /* Update summary */
    var countEl = section.querySelector('.ishaker-cart__summary-count');
    var totalEl = section.querySelector('.ishaker-cart__summary-total');
    if (countEl) countEl.textContent = cart.item_count + ' item' + (cart.item_count !== 1 ? 's' : '');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    /* Update header cart count */
    var headerCount = document.querySelector('.ishaker-cart-count');
    if (headerCount) headerCount.textContent = cart.item_count;

    /* Build a lookup: key → cart item */
    var itemMap = {};
    cart.items.forEach(function (item) {
      itemMap[item.key] = item;
    });

    /* Update or remove each row */
    var rows = section.querySelectorAll('.ishaker-cart__row');
    rows.forEach(function (row) {
      var key = row.dataset.key;
      var item = itemMap[key];

      if (!item) {
        /* Item was removed — animate out */
        row.style.transition = 'opacity 0.3s, transform 0.3s';
        row.style.opacity = '0';
        row.style.transform = 'translateX(-20px)';
        setTimeout(function () { row.remove(); checkEmpty(cart); }, 300);
        return;
      }

      /* Update quantity display */
      var qtyVal = row.querySelector('.ishaker-cart__qty-value');
      if (qtyVal) qtyVal.value = item.quantity;

      /* Update line price */
      var priceEl = row.querySelector('.ishaker-cart__row-price');
      if (priceEl) priceEl.textContent = formatMoney(item.final_line_price);

      /* Update button data attributes */
      var minusBtn = row.querySelector('.ishaker-cart__qty-minus');
      var plusBtn = row.querySelector('.ishaker-cart__qty-plus');
      if (minusBtn) minusBtn.dataset.qty = item.quantity - 1;
      if (plusBtn) plusBtn.dataset.qty = item.quantity + 1;
    });
  }

  /* Show empty state if cart is now empty */
  function checkEmpty(cart) {
    if (cart.item_count > 0) return;
    var layout = section.querySelector('.ishaker-cart__layout');
    if (!layout) return;

    while (layout.firstChild) layout.removeChild(layout.firstChild);

    var wrap = el('div', 'ishaker-cart__empty');

    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', '64');
    svg.setAttribute('height', '64');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    var c1 = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    c1.setAttribute('cx', '9'); c1.setAttribute('cy', '21'); c1.setAttribute('r', '1');
    var c2 = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    c2.setAttribute('cx', '20'); c2.setAttribute('cy', '21'); c2.setAttribute('r', '1');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6');
    svg.appendChild(c1); svg.appendChild(c2); svg.appendChild(path);

    var title = el('p', 'ishaker-cart__empty-title', 'Your cart is empty');
    var text = el('p', 'ishaker-cart__empty-text', 'Looks like you haven\'t added anything yet.');
    var btn = el('a', 'ishaker-cart__empty-btn', 'Continue Shopping');
    btn.href = '/';

    wrap.appendChild(svg);
    wrap.appendChild(title);
    wrap.appendChild(text);
    wrap.appendChild(btn);
    layout.appendChild(wrap);
  }

  /* ── Modal: remove item ── */
  function removeItem() {
    if (!pendingRemoveKey) return;
    btnDelete.disabled = true;
    btnCancel.disabled = true;

    changeCartItem(pendingRemoveKey, 0, function (cart) {
      closeModal();
      btnDelete.disabled = false;
      btnCancel.disabled = false;
      updateUI(cart);
    });
  }

  if (modal) {
    btnCancel.addEventListener('click', closeModal);
    btnClose.addEventListener('click', closeModal);
    backdrop.addEventListener('click', closeModal);
    btnDelete.addEventListener('click', removeItem);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  /* ── Quantity stepper clicks (optimistic + debounced) ── */
  section.addEventListener('click', function (e) {
    var btn = e.target.closest('.ishaker-cart__qty-btn');
    if (!btn) return;

    var key = btn.dataset.key;
    var qty = parseInt(btn.dataset.qty, 10);
    if (!key || isNaN(qty)) return;

    /* If quantity would become 0, show confirmation modal */
    if (qty <= 0) {
      openModal(key);
      return;
    }

    /* Optimistic: update DOM instantly */
    var row = btn.closest('.ishaker-cart__row');
    var unitPrice = parseInt(row.dataset.unitPrice || '0', 10);
    optimisticUpdate(row, qty, unitPrice);

    /* Queue the change and debounce the API call */
    pendingChanges[key] = qty;
    scheduleSyncCart();
  });

  /* ── Manual quantity input ── */
  section.addEventListener('change', function (e) {
    var input = e.target.closest('.ishaker-cart__qty-value');
    if (!input) return;
    applyInputQty(input);
  });

  section.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('.ishaker-cart__qty-value');
    if (!input) return;
    e.preventDefault();
    input.blur();
  });

  function applyInputQty(input) {
    var key = input.dataset.key;
    var qty = parseInt(input.value, 10);
    var row = input.closest('.ishaker-cart__row');

    if (!key || isNaN(qty) || qty < 0) {
      /* Reset to previous value from minus button */
      var minusBtn = row.querySelector('.ishaker-cart__qty-minus');
      input.value = minusBtn ? parseInt(minusBtn.dataset.qty, 10) + 1 : 1;
      return;
    }

    if (qty === 0) {
      openModal(key);
      return;
    }

    /* Optimistic update */
    var unitPrice = parseInt(row.dataset.unitPrice || '0', 10);
    optimisticUpdate(row, qty, unitPrice);

    /* Debounce API call */
    pendingChanges[key] = qty;
    scheduleSyncCart();
  }
})();
